export const prompt = {
	PROMPT_HEADER: {
		value: 'SURPRISE!',
		config: {
			fontName: 'custom_font',
			fontSize: 34,
			letterSpacing: 15,
			align: 'center'
		}
	},
	QUEST_PROMPT_HEADER: {
		value: 'CONGRATULATIONS!',
		config: {
			fontFamily: 'Japanese',
			fontSize: 50,
			letterSpacing: 2,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	QUEST_PROMPT_TITLE: {
		value: 'IN GIFTED QUEST YOU HAVE WON',
		config: {
			fill: '#DEB2BF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 28,
			wordWrap: true,
			wordWrapWidth: 400,
			align: 'center'
		}
	},
	QUEST_PROMPT_PRIZE: {
		value: '$1000',
		config: {
			fontName: 'custom_font',
			fontSize: 60
		}
	},
	QUEST_PROMPT_AMOUNT: {
		value: 'TOTAL',
		config: {
			fontName: 'custom_font',
			fontSize: 57,
			letterSpacing: 1
		}
	},
	QUEST_PROMPT_YES: {
		value: 'OK',
		config: {
			fill: '#FAF6E4',
			fontFamily: 'Poppins SemiBold',
			fontSize: 34
		}
	},
	PROMPT_TITLE: {
		value: 'AS A QUEST REWARD',
		config: {
			fill: '#DEB2BF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 28
		}
	},
	PROMPT_DESC: {
		value: '',
		config: {
			fill: '#DEB2BF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 28
		}
	},
	PROMPT_DESC_1: {
		value: '',
		config: {
			fill: '#DEB2BF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 28
		}
	},
	PROMPT_PRIZE: {
		value: '',
		config: {
			fontName: 'custom_font',
			fontSize: 57
		}
	},
	PROMPT_PRIZE_DISCOUNT: {
		value: '',
		config: {
			fontName: 'custom_font',
			fontSize: 36
		}
	},
	PROMPT_PRIZE_DESC: {
		value: '',
		config: {
			fill: '#DEB2BF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 28
		}
	},
	PROMPT_PRIZE_DESC_1: {
		value: '',
		config: {
			fill: '#DEB2BF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 28
		}
	},
	PROMPT_PRIZE_DESC_2: {
		value: '',
		config: {
			fill: '#DEB2BF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 28
		}
	},
	PROMPT_AMOUNT: {
		value: '',
		config: {
			fontName: 'custom_font',
			fontSize: 57,
			letterSpacing: 1
		}
	},
	PROMT_INFO: {
		value:
			'*IN CASE OF CHOOSING “CANCEL”, THIS REWARD WILL BE AVAILABLE ON THE QUEST PAGE AGAIN.',
		config: {
			fill: '#DEB2BF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 20,
			align: 'center',
			wordWrap: true,
			wordWrapWidth: 500
		}
	},
	PROMT_YES: {
		value: 'SPIN',
		config: {
			fill: '#DEB2BF',
			fontFamily: 'Poppins SemiBold',
			fontSize: 34
		}
	},
	PROMPT_NO: {
		value: 'CANCEL',
		config: {
			fill: '#E0C0C8',
			fontFamily: 'Poppins SemiBold',
			fontSize: 34
		}
	}
};
